var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOceanBrightGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "oceanBright"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6786f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6dbaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#83d9c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceanBrightGradient);
export default __webpack_public_path__ + "static/media/oceanBrightGradient.77f6912a79a34c74ee5db222834d8109.svg";
export { ForwardRef as ReactComponent };